exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nh1[data-v-5f0478ac] {\n  color: red\n}\n", ""]);

